// extracted by mini-css-extract-plugin
export default {"briefWrap":"brief_briefWrap__IFrAJ","time":"brief_time__tWlcu"};